import React from 'react';

interface SendIconProps {
  className?: string;
  size?: number;
}

const SendIcon: React.FC<SendIconProps> = ({ className = '', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.3166 22.1371C13.1366 22.1371 11.4666 21.3072 10.1466 17.3372L9.42656 15.1772L7.26656 14.4572C3.30656 13.1372 2.47656 11.4672 2.47656 10.2872C2.47656 9.11715 3.30656 7.43715 7.26656 6.10715L15.7566 3.27715C17.8766 2.56715 19.6466 2.77715 20.7366 3.85715C21.8266 4.93715 22.0366 6.71715 21.3266 8.83715L18.4966 17.3272C17.1666 21.3072 15.4966 22.1371 14.3166 22.1371ZM7.73656 7.53715C4.95656 8.46715 3.96656 9.56715 3.96656 10.2872C3.96656 11.0072 4.95656 12.1072 7.73656 13.0272L10.2566 13.8672C10.4766 13.9372 10.6566 14.1172 10.7266 14.3372L11.5666 16.8572C12.4866 19.6372 13.5966 20.6272 14.3166 20.6272C15.0366 20.6272 16.1366 19.6372 17.0666 16.8572L19.8966 8.36715C20.4066 6.82715 20.3166 5.56715 19.6666 4.91715C19.0166 4.26715 17.7566 4.18715 16.2266 4.69715L7.73656 7.53715Z"
        fill="currentColor"
      />
      <path
        d="M10.2066 14.9072C10.0166 14.9072 9.82656 14.8372 9.67656 14.6872C9.38656 14.3972 9.38656 13.9172 9.67656 13.6272L13.2566 10.0372C13.5466 9.74715 14.0266 9.74715 14.3166 10.0372C14.6066 10.3272 14.6066 10.8072 14.3166 11.0972L10.7366 14.6872C10.5966 14.8372 10.3966 14.9072 10.2066 14.9072Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SendIcon;
